import { render } from "./ModalHelp.vue?vue&type=template&id=31f45fca"
import script from "./ModalHelp.vue?vue&type=script&lang=js"
export * from "./ModalHelp.vue?vue&type=script&lang=js"

import "./ModalHelp.vue?vue&type=style&index=0&id=31f45fca&lang=css"

import exportComponent from "../../../superturbodb_manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__